import clsx from "clsx";
import React from "react";
import styles from "./TableFeatures.module.scss";

type Props = {
  size: "small" | "big";
  variant: "compact" | "extended";
  caption: string;
  columnCount: number;
};

export const TableFeatures: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  caption,
  columnCount,
  variant,
  size = "small"
}) => {
  return (
    <tbody
      className={clsx(styles.tableFeatures, {
        [styles.variantCompact]: variant == "compact",
        [styles.variantExtended]: variant == "extended",
        [styles.tableFeaturesSmall]: size == "small",
        [styles.tableFeaturesBig]: size == "big"
      })}
    >
      <tr className={styles.tableFeaturesTitle}>
        <th scope="column" colSpan={columnCount} className={styles.caption}>
          {caption}
        </th>
      </tr>
      {children}
    </tbody>
  );
};
